import { config } from '@iheartjane/config';

import { api } from '@jane/shared/data-access';
import type { Cart, EmptyCart } from '@jane/shared/types';

import type {
  AddCartProductBody,
  AddCartProductReturnType,
  OptimizeSpecialsParams,
  RemoveCartProductBody,
  RemoveCartProductReturnType,
  UpdateCartProductParams,
  UpdateCartProductsReturnType,
} from './cartProducts.type';

const cartUrl = () => `${config.apiPath}/carts`;
const cartProductsUrl = () => `${config.apiPath}/cart_products`;

export const cartProductsUrls = {
  optimizeSpecials: () => `${cartUrl()}/optimize_specials`,
  addCartProduct: () => cartProductsUrl(),
  removeCartProduct: (productId: string | number) =>
    `${cartProductsUrl()}/${productId}`,
  updateCartProduct: (productId: string | number) =>
    `${cartProductsUrl()}/${productId}`,
};

type MaybeCart = Cart | EmptyCart;
export const optimizeSpecials = async (data: OptimizeSpecialsParams) => {
  const { cart } = await api.patch<{ cart: MaybeCart }>(
    cartProductsUrls.optimizeSpecials(),
    { ...data }
  );
  return cart;
};

export const addCartProduct = async (data: AddCartProductBody) => {
  return await api.post<AddCartProductReturnType>(
    cartProductsUrls.addCartProduct(),
    data
  );
};

export const removeCartProduct = async (body: RemoveCartProductBody) => {
  return await api.delete<RemoveCartProductReturnType>(
    cartProductsUrls.removeCartProduct(body.product_id),
    {
      body: JSON.stringify(body),
    }
  );
};

export const updateCartProducts = async (data: UpdateCartProductParams) => {
  return await api.patch<UpdateCartProductsReturnType>(
    cartProductsUrls.updateCartProduct(data.product.product_id),
    data
  );
};
